import {TopNavigation} from '@frontend/modules/layout/top_navigation/TopNavigation'
import {AdsSearchPanel} from '@frontend/modules/public/ads/components/search/AdsSearchPanel'
import {useTopMenuStore} from '@frontend/stores'
import clsx from 'clsx'

// Заголовок страницы.
export function Header() {

    const topMenuStickToTop = useTopMenuStore(
        state => state.stickToTop
    )
    const topMenuWrapInCard = useTopMenuStore(
        state => state.wrapInCard
    )

    return (
        <header className={topMenuStickToTop ? 'stick-to-top' : ''}>
            <div className="container-fluid container-xl">
                <div
                    className={clsx(
                        'header-content',
                        topMenuWrapInCard ? 'card' : null
                    )}
                >
                    <TopNavigation />
                    <AdsSearchPanel />
                </div>
            </div>
        </header>
    )
}
